import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as store from 'store';

import {
  isRequiredNumber,
  proportionValidator
} from 'utilities/validators';

import TestSelectionComponent from './Component';

const {
  form: {
    randomizationHypothesisTesting: {
      getTestSelection,
      getPrimaryParameterType,
      isSecondaryParameterSelected
    }
  }
} = store;

const isSlopeOrCorrelation = value =>
  value === 'slope' || value === 'correlation';

class TestSelectionContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.nullValueValidator = value =>
      this.props.testSelection === 'proportion'
        ? proportionValidator(value)
        : isRequiredNumber(value);
  }

  get options () {
    const {
      primaryParameterType,
      secondaryParameterSelected
    } = this.props;

    if (primaryParameterType === 'numerical' && secondaryParameterSelected) {
      return [
        {
          value: 'slope',
          label: 'Slope',
          text: 'Slope'
        },
        {
          value: 'correlation',
          label: 'Correlation',
          text: 'Correlation'
        }
      ];
    }

    switch (this.props.primaryParameterType) {
      case 'numerical':
        return [
          {
            value: 'mean',
            label: 'Mean',
            text: 'Mean'
          }
        ];
      case 'categorical':
        return [
          {
            value: 'proportion',
            label: 'Proportion',
            text: 'Proportion'
          },
          {
            value: 'count',
            label: 'Count',
            text: 'Count'
          }
        ];
      default:
        return [];
    }
  }

  get isSlopeOrCorrelation () {
    return isSlopeOrCorrelation(
      this.props.testSelection
    );
  }

  render () {
    /* eslint-disable */

    const {
      testSelection,
      primaryParameterType,
      secondaryParameterSelected,

      ...props
    } = this.props

    /* eslint-enable */

    return (
      <TestSelectionComponent
        isSlopeOrCorrelation={this.isSlopeOrCorrelation}
        nullValueValidator={this.nullValueValidator}
        options={this.options}
        {...props}
      />
    );
  }
}

TestSelectionContainer.propTypes = {
  testSelection: PropTypes.string.isRequired,
  primaryParameterType: PropTypes.string.isRequired,
  secondaryParameterSelected: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  testSelection: getTestSelection(state),
  primaryParameterType: getPrimaryParameterType(state),
  secondaryParameterSelected: isSecondaryParameterSelected(state)
});

export default connect(mapStateToProps)(TestSelectionContainer);
